// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
// import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy/index';
import phoneLink from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
// import('./components/plUpload/fg.upload');                // PL upload
import 'bootstrap/js/dist/collapse';

cookiesPolicy({
  enableModal: true,
  enableImg: false,
  messages: {
    cs: {
      heading: 'Aby web fungoval, jak má<br/><small>(nastavení cookies)</small>',
    },
  },
});

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
// autoTitleLinksWithBlankTarget();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/configureWeb.js